import DesignSystem from '@design_system/index.vue'

import Finish from '@/views/Finish.vue'
import Register from '@/views/Register.vue'
import VerificationEmail from '@/views/VerificationEmail.vue'
import RegisterFinishPFStep1 from '@/views/pf/finish/step-1.vue'
import RegisterFinishPFStep2 from '@/views/pf/finish/step-2.vue'
import RegisterFinishPFStep3 from '@/views/pf/finish/step-3.vue'
import RegisterPFStep1 from '@/views/pf/step-1.vue'
import RegisterPFStep2 from '@/views/pf/step-2.vue'
import RegisterPFStep3 from '@/views/pf/step-3.vue'
import RegisterFinishPJStep1 from '@/views/pj/finish/step-1.vue'
import RegisterFinishPJStep2 from '@/views/pj/finish/step-2.vue'
import RegisterFinishPJStep3 from '@/views/pj/finish/step-3.vue'
import RegisterStep1PJ from '@/views/pj/step-1.vue'
import RegisterStep2PJ from '@/views/pj/step-2.vue'
import RegisterStep3PJ from '@/views/pj/step-3.vue'
import RegisterStep4PJ from '@/views/pj/step-4.vue'

export default [
  {
    path: '/',
    redirect: '/register'
  },
  {
    path: '/register',
    name: 'Register',
    component: Register
  },
  {
    path: '/verification',
    name: 'VerificationEmail',
    component: VerificationEmail
  },
  {
    path: '/finalizado',
    name: 'Finish',
    component: Finish
  },
  {
    path: '/register/pf',
    redirect: '/register/pf/step-1',
    children: [
      {
        path: 'step-1',
        name: 'RegisterPFStep1',
        component: RegisterPFStep1
      },
      {
        path: 'step-2',
        name: 'RegisterPFStep2',
        component: RegisterPFStep2
      },
      {
        path: 'step-3',
        name: 'RegisterPFStep3',
        component: RegisterPFStep3
      }
    ]
  },
  {
    path: '/finalizar-cadastro',
    children: [
      {
        path: 'pessoais',
        name: 'RegisterFinishPFStep1',
        component: RegisterFinishPFStep1
      },
      {
        path: 'banco',
        name: 'RegisterFinishPFStep2',
        component: RegisterFinishPFStep2
      },
      {
        path: 'documentos',
        name: 'RegisterFinishPFStep3',
        component: RegisterFinishPFStep3
      },
      {
        path: '',
        name: 'RegisterFinishPJStep1',
        component: RegisterFinishPJStep1
      },
      {
        path: 'bancos-pj',
        name: 'RegisterFinishPJStep2',
        component: RegisterFinishPJStep2
      },
      {
        path: 'documentos-pj',
        name: 'RegisterFinishPJStep3',
        component: RegisterFinishPJStep3
      }
    ]
  },

  {
    path: '/register/pj',
    redirect: '/register/pj/step-1',
    children: [
      {
        path: 'step-1',
        name: 'RegisterPJStep1',
        component: RegisterStep1PJ
      },
      {
        path: 'step-2',
        name: 'RegisterPJStep2',
        component: RegisterStep2PJ
      },
      {
        path: 'step-3',
        name: 'RegisterPJStep3',
        component: RegisterStep3PJ
      },
      {
        path: 'step-4',
        name: 'RegisterPJStep4',
        component: RegisterStep4PJ
      }
    ]
  },
  {
    path: '/:catchAll(.*)',
    redirect: '/'
  },
  {
    path: '/design-system',
    component: DesignSystem,
    name: 'DesignSystem',
    meta: { requiresAuth: false }
  }
]
